import RequestWrapper from "./requestWrapper";

export default function(dispatcher) {
    return new RequestWrapper(dispatcher);
}